module.exports = __webpack_public_path__ + "img/project-6copy.6e74dcb9.jpg";